import strings from 'utils/strings'
import { isNil, isEmpty, equals, prop, compose, head } from 'ramda'
import { capitalizeFirst } from 'utils/utils'

import {
  NO_EDGE,
  RISING_EDGE,
  FALLING_EDGE,
  BOTH_EDGES,
  ACTIVE_HIGH,
  ACTIVE_LOW,
  VOLT_0_18K5,
  VOLT_0_6,
  RES_0_100k,
  RES_0_500,
  VOLT_0_16_rel,
  NOT_CONFIGURED,
} from 'utils/constants'

const edgeLabelMap = {
  [NO_EDGE]: strings.no_edge,
  [RISING_EDGE]: strings.rising_edge,
  [FALLING_EDGE]: strings.falling_edge,
  [BOTH_EDGES]: strings.both_edges,
}
export const edgeLabel = (edge) => edgeLabelMap[edge]

const configurableInputValMap = {
  [ACTIVE_HIGH]: strings.active_high,
  [ACTIVE_LOW]: strings.active_low,
  [VOLT_0_18K5]: strings.volt_0_18k5,
  [VOLT_0_6]: strings.volt_0_6,
  [RES_0_100k]: strings.res_0_100k,
  [RES_0_500]: strings.res_0_500,
  [VOLT_0_16_rel]: strings.volt_0_16_rel,
  [NOT_CONFIGURED]: strings.not_configured,
}
export const configurableInputValueLabel = (value) =>
  configurableInputValMap[value]

export const getSwitchPositionLabel = (inputSignalUri, positionsArray) => {
  if (isNil(inputSignalUri) || isEmpty(positionsArray)) return ''
  const isSelected = positionsArray.filter(({ value }) =>
    equals(inputSignalUri, value)
  )
  const position = compose(prop('position'), head)(isSelected)
  return capitalizeFirst(position)
}
